// Module
var code = "<svg width=\"24\" height=\"24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><rect x=\"4.5\" y=\"4.5\" width=\"15\" height=\"15\" rx=\"2.5\" fill=\"#3B3B3B\" stroke=\"#3B3B3B\"/><rect x=\"8\" y=\"12\" width=\"8\" height=\"1\" rx=\".5\" fill=\"#fff\"/></svg>";
// Exports
module.exports = code;